export const OPTIONAL_INFERABLE_KEYS = new Set<string>([
    "rooftopUnitSupplyAirRate",
    "rooftopUnitAverageInstallationYear",
    "airHandlingEquipmentSupplyAirRate",
    "airHandlingEquipmentAverageInstallationYear",
    "centralPlantCoolerSize",
    "centralPlantCoolerAverageInstallationYear",
    "centralPlantHeaterSize",
    "centralPlantHeaterAverageInstallationYear",
    "centralPlantHeatPumpSize",
    "centralPlantHeatPumpAverageInstallationYear",
    "terminalHeaterSize",
    "terminalHeaterCoolerSize",
    "terminalHeaterAverageInstallationYear",
    "terminalCoolerSize",
    "terminalCoolerAverageInstallationYear",
    "heatPumpSize",
    "heatPumpInstallationYear",
    "domesticHotWaterHeaterSize",
    "domesticHotWaterHeaterAverageInstallationYear",
    "clothesDryersEnergyDensity",
    "clothesDryersAverageInstallationYear",
    "clothesWashersEnergyDensity",
    "clothesWashersAverageInstallationYear",
    "elevatorsQuantity",
    "elevatorsAverageInstallationYear",
    "rooftopPhotovoltaicsSize",
    "rooftopPhotovoltaicsAverageInstallationYear",
    "escalatorQuantity",
    "escalatorInstallationYear",
]);

export const DERIVED_READ_ONLY_KEYS = new Set([
    "domesticHotWaterHeaterExists",
    "centralPlantCoolerExists",
    "centralPlantHeaterExists",
    "centralPlantHeatPumpExists",
    "centralPlantGenericEquipmentExists",
    "terminalCoolerExists",
    "terminalHeaterExists",
    "heatPumpExists",
    "rooftopUnitCoolingType",
    "heatPumpType",
    "heatPumpHeatingCoefficientOfPerformance",
    "heatPumpCoolingCoefficientOfPerformance",
    "heatPumpHeatingLoadRatio",
    "heatPumpCoolingLoadRatio",
]);

export const PRIMARY_SURVEY_KEY_FOR_DERIVED_EXISTS: Record<string, string> = {
    domesticHotWaterHeaterExists: "domesticHotWaterHeaterType",
    centralPlantCoolerExists: "centralPlantCoolerType",
    centralPlantHeaterExists: "centralPlantHeaterType",
    centralPlantHeatPumpExists: "centralPlantHeatPumpType",
    centralPlantGenericEquipmentExists: "centralPlantGenericEquipmentName",
    terminalCoolerExists: "terminalCoolerUnits",
    terminalHeaterExists: "terminalHeaterUnits",
    heatPumpExists: "heatPumpType",
};

export const CUSTOM_CENTRAL_EQUIPMENT_KEYS: (keyof CentralPlantGenericEquipment)[] = [
    "centralPlantGenericEquipmentName",
    "centralPlantGenericEquipmentSize",
    "centralPlantGenericEquipmentSizeUnits",
    "centralPlantGenericEquipmentCoefficientOfPerformance",
    "centralPlantGenericEquipmentFuel",
    "centralPlantGenericEquipmentEndUse",
    "centralPlantGenericEquipmentLoadRatio",
    "centralPlantGenericEquipmentInstallationYear",
];

export const TERMINAL_SECTION_EDITABLE_KEY_ORDER: Record<string, string[]> = {
    "Terminal cooling units": ["terminalCoolerUnits", "terminalCoolerSize", "terminalCoolerAverageInstallationYear"],
    "Terminal heating units": [
        "terminalHeaterUnits",
        "terminalHeaterSize",
        "terminalHeaterCoolerSize",
        "terminalHeaterAverageInstallationYear",
    ],
    "Heat pump terminal units": ["heatPumpType", "heatPumpSize", "heatPumpInstallationYear"],
};
